import { useState } from 'react';
import { useUser } from 'features/auth';
import { CreateJournalNoteModal } from '../create-journal-note-modal';
import { PlaceholderTrigger } from '../placeholder-trigger';

const CreateJournalNoteTrigger = () => {
  const [isModalOpened, setIsModalOpened] = useState(false);
  const { railsUserData: viewer } = useUser();

  return (
    <>
      <PlaceholderTrigger
        onClick={() => {
          setIsModalOpened(true);
        }}
        placeholder="Create note..."
        profilePhoto={viewer.profilePhoto}
      />
      <CreateJournalNoteModal
        isOpened={isModalOpened}
        onCancel={() => {
          setIsModalOpened(false);
        }}
      />
    </>
  );
};

export default CreateJournalNoteTrigger;
